import React, {FC} from 'react'

//@ts-ignore
import { LKModalTrigger } from 'shared/LKModal'

const TagAddTrigger: FC<{
  children: React.ReactElement | string,
  permission: string
}> = ({ children, permission }) => (
  <LKModalTrigger name="TagAdd" alias="add" permission={permission}>
    {children}
  </LKModalTrigger>
)

export default TagAddTrigger
